__turbopack_context__.v({
  "badgeSlot": "HowItWorks-module__DprxOG__badgeSlot",
  "card": "HowItWorks-module__DprxOG__card",
  "cardBody": "HowItWorks-module__DprxOG__cardBody",
  "cardTitle": "HowItWorks-module__DprxOG__cardTitle",
  "carousel": "HowItWorks-module__DprxOG__carousel",
  "grid": "HowItWorks-module__DprxOG__grid",
  "heading": "HowItWorks-module__DprxOG__heading",
  "section": "HowItWorks-module__DprxOG__section",
  "shot": "HowItWorks-module__DprxOG__shot",
  "shotWrap": "HowItWorks-module__DprxOG__shotWrap",
  "stepBadge": "HowItWorks-module__DprxOG__stepBadge",
  "subtitle": "HowItWorks-module__DprxOG__subtitle",
  "textStack": "HowItWorks-module__DprxOG__textStack",
});
